import React, { useEffect } from 'react'
import { Spinner } from '@epam/loveship'
import { OAUTH_EPAM } from '../../constants/urls'
import { useGetUserQuery } from '../../store'
import { useActions } from '../../hooks/redux/actions'
import { useAppSelector } from '../../hooks/redux/redux'

type AuthWrapperProps = {
  children: React.ReactNode
}

export const AuthWrapper = ({ children }: AuthWrapperProps) => {
  const { userInfo } = useAppSelector((state) => state.users)
  const { data, isError, error, isLoading } = useGetUserQuery()
  const { setUserInfo } = useActions()

  useEffect(() => {
    if (data && !userInfo) {
      setUserInfo(data)
    }
  }, [data, userInfo, setUserInfo])

  if (isError) {
    if ('status' in error && error.status === 401) {
      window.location.href = OAUTH_EPAM
    } else {
      console.error(error)
      throw Error('User login error', { cause: error })
    }
  }

  if (isLoading || userInfo === null) {
    return <Spinner />
  }

  if (userInfo) {
    return <>{children}</>
  }

  return null
}
